import React from 'react'
import { useSelector } from 'react-redux'
import {
  CAccordion,
  CAccordionItem,
  CAccordionHeader,
  CAccordionBody
} from '@coreui/react'
import LinearChart from './LinearChart'
import LegendInfo from './LegendInfo'
import { ReactComponent as ShowIcon } from '../assets/images/openShow.svg'
import { ReactComponent as HideIcon } from '../assets/images/closeHide.svg'
import { modalConfigs } from '../data/modalConfig'

const Accordion = ({ openIndices, setOpenIndices, modalData }) => {
  const layerOrder = ['aqi_eu', 'pm25', 'pm10', 'no2', 'o3']
  const varsDark = {
    '--cui-accordion-bg': '#212121',
    '--cui-accordion-border': '#212121',
    '--cui-accordion-active-bg': '#212121',
    '--cui-accordion-btn-bg': '#212121',
    '--cui-accordion-btn-border': '#212121',
    '--cui-accordion-btn-padding-y': '0rem',
    '--cui-accordion-btn-padding-x': '1rem'
  }
  const varsLight = {
    '--cui-accordion-bg': '#FFFFFF',
    '--cui-accordion-border': '#FFFFFF',
    '--cui-accordion-active-bg': '#FFFFFF',
    '--cui-accordion-btn-bg': '#FFFFFF',
    '--cui-accordion-btn-border': '#FFFFFF',
    '--cui-accordion-btn-padding-y': '0rem',
    '--cui-accordion-btn-padding-x': '1rem'
  }
  const theme = useSelector((state) =>
    state.mapStyle.darkMode ? 'dark' : 'light'
  )
  return (
    <CAccordion className='mb-6' style={theme === 'dark' ? varsDark : varsLight}>
      {layerOrder.map((key, index) => {
        const value = modalData[0].properties[key]
        if (value === undefined || !modalConfigs[key]) return null
        const config = modalConfigs[key]

        return (
          <CAccordionItem key={key} className='border-0'>
            <CAccordionHeader
              className='flex items-center rounded-t-lg justify-between w-fullh h-18  bg-[#353535]  hover:bg-zinc-700 border-0 border-zinc-800  focus:bg-[#353535] text-zinc-300  border-zinc-800'
              onClick={() => {
                if (openIndices.includes(index)) {
                  setOpenIndices(openIndices.filter((i) => i !== index))
                } else {
                  setOpenIndices([index])
                }
              }}
            >
              <div className='flex items-center'>
                <div className='w-full flex items-center'>
                  <div className='mr-2'>
                    <LinearChart
                      values={config.values}
                      type={config.title}
                      min={config.min}
                      max={config.max}
                      colors={config.colors}
                      data={value}
                      markerPosition={value}
                      style={{ width: '100%' }}
                    />
                  </div>
                  <div className='w-full flex justify-between items-center'>
                    <div>
                      <div
                        className='text-[9px] font-bold text-zinc-200 pt-14'
                      >
                        {config.title}{' '}
                        {config.title !== 'AQI' && (
                          <span
                            className='text-[9px] font-bold text-zinc-200 pt-14'
                          >
                            μg/m
                            <sup>
                              <small>3</small>
                            </sup>
                          </span>
                        )}
                      </div>
                    </div>
                    <div className={index === 0 ? 'absolute right-6' : 'absolute right-6'}>
                      {openIndices.includes(index)
                        ? (
                          <HideIcon
                            style={{
                              marginLeft: index === 0 ? '' : ''
                            }}
                          />
                          )
                        : (
                          <ShowIcon
                            style={{
                              marginLeft: index === 0 ? '14px' : ''
                            }}
                          />
                          )}
                    </div>
                  </div>
                </div>
              </div>
            </CAccordionHeader>
            <CAccordionBody>
              <div className='p-2'>
                <div className='flex flex-col items-center py-4 mb-4 text-[10px] text-gray-400'>
                  {config.info}
                  <LegendInfo
                    config={config}
                    type={modalData[0].properties.aqi_eu}
                  />
                </div>
              </div>
            </CAccordionBody>
          </CAccordionItem>
        )
      })}
    </CAccordion>
  )
}

export default Accordion
